module.exports = __webpack_public_path__ + "static/media/TimeTrain_Maths.923ade0e.gif";